import { observable, action } from "mobx";
import CountryRepository from "~/repository/CountryRepository";
import CachedRepository from "~/utils/CachedRepository";
import Country from "~/models/Country";

class CountryStore {
  @observable loading = false;

  @observable countries = [];

  countryRepository = null;

  CachedRepository = null;

  constructor() {
    this.countryRepository = new CountryRepository();
    this.cachedRepository = new CachedRepository();
  }

  @action
  load() {
    if (this.loading) {
      return Promise.resolve();
    }

    this.loading = true;

    return this.cachedRepository
      .cacheResponse("countries", () => {
        return this.countryRepository.fetch();
      })
      .then(countriesResult => {
        this.processIncomingCountries(countriesResult);
      })
      .finally(() => {
        this.loading = false;
      });
  }

  @action
  processIncomingCountries(countriesResult) {
    this.countries.clear();

    Object.keys(countriesResult.data.countries).forEach(key => {
      const country = countriesResult.data.countries[key];
      this.countries.push(new Country(country));
    });

    // Place USA and Canada to the top.
    const Canada = this.countries.find(country => country.id === "Canada");
    const USA = this.countries.find(country => country.id === "USA");

    this.countries.splice(this.countries.indexOf(Canada), 1);
    this.countries.splice(this.countries.indexOf(USA), 1);

    this.countries.unshift(Canada);
    this.countries.unshift(USA);
  }
}

export default CountryStore;
